// extracted by mini-css-extract-plugin
module.exports = {"tag":"cp_n3","tag_negative":"cp_n4"};